import React from 'react'

export default function Loading({ texto = 'A carregar...' }) {
  return (
    <div style={{ textAlign: 'center', padding: '48px 24px', color: 'var(--cor-texto-suave)' }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      <div style={{
        width: '36px',
        height: '36px',
        border: '3px solid var(--cor-creme-escuro)',
        borderTop: '3px solid var(--cor-principal)',
        borderRadius: '50%',
        margin: '0 auto 16px',
        animation: 'spin 0.8s linear infinite',
      }} />
      <p style={{ fontSize: '14px' }}>{texto}</p>
    </div>
  )
}
